import React from 'react';
import DynamicLink from '../DynamicLink';
import { MdKeyboardArrowDown } from 'react-icons/md';
import * as styles from './GlobalNav.module.styl';

const MenuItem = ({ item, isActive = false, setActiveSubMenu }) => {
  if (item?.sub_menu?.length > 0 || item?.integrations?.length > 0) {
    // Dropdown menu item
    return (
      <span
        href="#"
        onClick={() => setActiveSubMenu(isActive ? '' : item.title)}
        className={isActive ? styles.dropdownActive : null}
      >
        {item.title}
        <MdKeyboardArrowDown
          style={{
            transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </span>
    );
  } else if (item?.title && item?.link_url) {
    // Regular menu item
    return (
      <DynamicLink activeClassName={styles.active} link={item.link_url}>
        {item.title}
      </DynamicLink>
    );
  } else return null;
};

export default MenuItem;
